import React, { useState, useEffect, useContext, useCallback } from "react";
import { TranslatorContext } from "../../../context/Translator";
import axios from "axios";
import { ButtonComponent } from "../../../components/elements";
import { Table, Row, Col } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useNavigate } from "react-router-dom";

export default function SalaryExpensesIndex() {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const API_BASE = `${process.env.REACT_APP_API_URL}/admin/salary-expenses`;
    const authHeaders = { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } };

    const [salaryExpenses, setSalaryExpenses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const fetchSalaryExpenses = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(API_BASE, authHeaders);
            setSalaryExpenses(res.data?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [API_BASE]);

    useEffect(() => {
        fetchSalaryExpenses();
    }, [fetchSalaryExpenses]);

    const handleDelete = async () => {
        if (!deleteId) return;
        setActionLoading(true);
        try {
            await axios.delete(`${API_BASE}/${deleteId}`, authHeaders);
            fetchSalaryExpenses();
            setDeleteId(null);
        } catch (err) {
            console.error("Delete Error:", err);
        } finally {
            setActionLoading(false);
        }
    };

    if (loading) {
        return <PageLayout><p>{t("loading")}...</p></PageLayout>;
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">{t("salary expenses")}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t("home")}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t("salary expenses")}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header d-flex justify-content-between align-items-center p-3">
                            <h5 className="mc-card-title mb-0">{t("salary expense list")}</h5>
                            <ButtonComponent
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => navigate("/salary-expenses/create")}
                            >
                                <i className="material-icons me-1">add</i>
                                {t("add salary expense")}
                            </ButtonComponent>
                        </div>

                        <Row>
                            <Col xl={12}>
                                <div className="mc-card">
                                    <div className="table-responsive-wrapper">
                                        <Table responsive className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th><div className="mc-table-check"><p>#</p></div></th>
                                                    <th>{t("employee")}</th>
                                                    <th>{t("salary month")}</th>
                                                    <th>{t("date")}</th>
                                                    <th>{t("salary")}</th>
                                                    <th>{t("paid amount")}</th>
                                                    <th>{t("bank")}</th>
                                                    <th>{t("actions")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salaryExpenses.map((item, index) => (
                                                    <tr key={item.id || index}>
                                                        <td><div className="mc-table-check"><p>{index + 1}</p></div></td>
                                                        <td>{item.employee?.name || "-"}</td>
                                                        <td>{item.salary_month}</td>
                                                        <td>{item.date}</td>
                                                        <td>{item.salary}</td>
                                                        <td>{item.payment?.amount || "-"}</td>
                                                        <td>{item.payment?.bank?.name || "-"}</td>
                                                        <td>
                                                            <div className="mc-table-action">
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons edit me-2"
                                                                    onClick={() => navigate(`/salary-expenses/edit/${item.id}`)}
                                                                    title="Edit"
                                                                >
                                                                    edit
                                                                </ButtonComponent>
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons delete"
                                                                    onClick={() => setDeleteId(item.id)}
                                                                    title="Delete"
                                                                >
                                                                    delete
                                                                </ButtonComponent>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {deleteId && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="mc-alert-modal p-4 text-center">
                                <i className="material-icons" style={{ fontSize: "50px", color: "red" }}>new_releases</i>
                                <h3 className="mt-3">{t("Are you sure?")}</h3>
                                <p>{t("Want to delete this salary expense record?")}</p>
                                <div className="d-flex justify-content-center gap-2 mt-3">
                                    <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setDeleteId(null)}>
                                        {t("close")}
                                    </ButtonComponent>
                                    <ButtonComponent type="button" className="btn btn-danger" onClick={handleDelete} disabled={actionLoading}>
                                        {actionLoading ? <span className="spinner-border spinner-border-sm me-2"></span> : t("delete")}
                                    </ButtonComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </PageLayout>
    );
}